import {
  Candy,
  Cookie,
  Popcorn,
  Soup,
  CupSoda,
  DoorOpen,
  Store,
  User,
  Home,
  Phone,
} from "lucide-react";

export const STORE_ZONES = [
  { id: "candy-jars", label: "Toffee & Candy Jars", x: 16, y: 30, type: "shelf", icon: Candy, color: "#E9C46A" },
  { id: "chocolate-counter", label: "Chocolates", x: 40, y: 25, type: "shelf", icon: Cookie, color: "#8B5A2B" },
  { id: "biscuit-shelf", label: "Biscuits", x: 63, y: 27, type: "shelf", icon: Cookie, color: "#D4A373" },
  { id: "chips-wall", label: "Chips & Namkeen", x: 85, y: 33, type: "shelf", icon: Popcorn, color: "#E76F51" },
  { id: "drinks-fridge", label: "Cold Drinks Fridge", x: 45, y: 70, type: "shelf", icon: CupSoda, color: "#457B9D" },
  { id: "churan-counter", label: "Churan Counter", x: 70, y: 72, type: "shelf", icon: Soup, color: "#9C6644" },
  { id: "shopkeeper", label: "Kaka (Shopkeeper)", x: 24, y: 66, type: "npc", icon: User, color: "#C84B31" },
  { id: "exit-door", label: "Go Outside", x: 6, y: 88, type: "door", icon: DoorOpen, color: "#6D4C41" },
];

export const STREET_ZONES = [
  { id: "shop-entrance", label: "Enter Kirana Store", x: 50, y: 46, type: "door", icon: Store, color: "#C84B31" },
  { id: "pco-booth", label: "STD/PCO Booth", x: 16, y: 60, type: "pco", icon: Phone, color: "#E9A700" },
  { id: "home-exit", label: "Nostalgic World", x: 90, y: 82, type: "door", icon: Home, color: "#6D4C41" },
];

export const SHOPKEEPER_LINES = [
  "Aur kuch beta?",
  "₹5 ka de deta hoon.",
  "Khata mein likh doon?",
  "Beta, packet sambhal ke.",
  "Taaza maal hai, le lo.",
];

export const SHOPKEEPER_OPTIONS = [
  { text: "Kuch meetha?", zone: "candy-jars" },
  { text: "Chocolate?", zone: "chocolate-counter" },
  { text: "Biscuit?", zone: "biscuit-shelf" },
  { text: "Chips?", zone: "chips-wall" },
  { text: "Thanda?", zone: "drinks-fridge" },
  { text: "Churan?", zone: "churan-counter" },
];
